export default {
  //parkid忽略接口：配置为接口名
  ignorePark: ['ioclogout', 'deleteVcnDevices', 'updateCameraFeature']
}